import { tokens } from 'src/design-system';
import { mediaDown } from 'src/design-system/mixins/responsive';
import { createStyles } from "src/hooks/useStyles";
import { buttonStyle } from "src/Library/CommonStyles";

function getVariableStyle() {
  const obj = {
    Not_Started: '#F4F4F4',
    In_Progress: '#FFFED2',
    Done: '#D3FFEA',
    Cancelled: '#FFD3D3',
  };
  const getBase = (color) => {
    return {
      '& .ant-select-selection--single': {
        backgroundColor: color,
        border: 0,
      },
    };
  };
  const result = {};
  for (const i in obj) {
    result[`select-${i}`] = getBase(obj[i]);
  }
  return result;
}

const styles = createStyles((theme: any, props) => ({
  milestoneName: {
    fontSize: tokens.fontSize.body,
    color: tokens.colors.text,
    fontWeight: tokens.fontWeight.semibold,
    width: 80,
  },
  taskDoneLabel: {
    fontSize: 8,
    color: tokens.colors.textSecondary,
    width: 10,
    marginRight: 10,
  },
  ...mediaDown(1200, {
    modal: {
      minWidth: '800px',
    },
  }),
  modal: {
    '& .ant-modal-body': {
      padding: 0,
    },
    backgroundColor: tokens.colors.bgWhite,
  },
  derivedCol: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  statusCircle: {
    width: 12,
    height: 12,
    marginRight: tokens.spacing.sm,
    borderRadius: tokens.spacing.sm,
  },
  errorBlock: {
    margin: '15px',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: `${tokens.spacing.md}px ${tokens.spacing.lg}px 0px`,
  },
  table: {
    margin: `${tokens.spacing.md}px 0`,
    borderRadius: tokens.radius.sm,
    background: '#fff',
    cursor: 'pointer',
    '& .ant-table-align-left': {
      backgroundColor: '#d5d5d5',
    },
    '& .ant-table-thead': {
      fontSize: tokens.fontSize.body,
      whiteSpace: 'pre-line !important',
      border: `1px solid ${tokens.colors.border}`,
      color: '#424242',
      // backgroundColor: '#E8E8E8',
      padding: 0,
    },
    '& .ant-table-tbody > tr > td': {
      verticalAlign: 'top',
    },
    '& .ant-table-tbody > tr': {
      '&:hover': {
        '& #pendingCount': {
          backgroundColor: 'unset',
        },
      },
    },
    '& .ant-table-thead .ant-table-column-title': {
      whiteSpace: 'nowrap',
    },
  },
  toolbarFilter: {
    display: 'flex',
    background: '#fff',
    justifyContent: 'space-between',
    padding: '15px 0px',
    margin: `${tokens.spacing.lg}px ${tokens.spacing.lg}px 0px`,
    flexWrap: 'wrap',
    borderRadius: tokens.radius.md,
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.2)',
  },
  ellipsisClass: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '150px',
    textOverflow: 'ellipsis',
  },
  flexBox: {
    display: 'flex',
    alignItems: 'center',
  },
  ellipsisIcon: {
    fontSize: 20,
    cursor: 'pointer',
  },
  actionCol: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  parentDiv: {
    paddingBottom: '50px',
  },
  noTaskDiv: {
    width: '100%',
    height: '173px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: tokens.colors.bgWhite,
  },
  addTaskDiv:{
    padding: '2px 10px',
    borderRadius: 13,
    backgroundColor: '#FAFAFA',
    fontSize: tokens.fontSize.small,
    color: tokens.colors.primaryDark,
    fontWeight: tokens.fontWeight.semibold,
    '&:hover': {
      backgroundColor: '#EDEDED',
    }
  },
  taskRow: {
    height: 62,
  },
  disabledRow: {
    opacity: .5,
  },
  deadlinePassedRow: {
    backgroundColor: '#ff000011',
  },
  nameLabel: {
    border: '1px solid black',
    borderRadius: 10,
    background: 'white',
    marginLeft: 10,
    marginRight: 10,
    fontFamily: 'Open Sans SemiBold',
    fontSize: tokens.fontSize.caption,
    paddingLeft: 5,
    paddingRight: 5,
    whiteSpace: 'nowrap',
    height: 17,
  },
  nameLabelPending: {
    borderColor: '#8B1FCA',
    color: '#8B1FCA',
    background: '#F0D6FF',
  },
  nameLabelRejected: {
    borderColor: '#F24E4E',
    color: '#F62C2C',
    background: '#FFEFEF',
  },
  nameLabelRequested: {
    borderColor: '#4A4650',
    color: '#4A4650',
    background: '#F2EFF5',
  },
  nameLabelApproved: {
    borderColor: tokens.colors.success,
    color: tokens.colors.success,
    background: '#E0FFEB',
  },
  collapse: {
    '& .ant-collapse-content-box': {
      padding: 0,
    },
    '& .ant-table-wrapper': {
      margin: 0,
    },
    '& .ant-collapse-content': {
      border: 0,
    },
    '& .ant-table-small': {
      border: 0,
    },
    marginBottom: 5,
    border: 0,
  },
  progress: {
    '& .ant-progress-inner': {
      background: '#ededed',
      borderRadius: 0,
    },
    '& .ant-progress-bg': {
      borderRadius: 0,
    },
    '& .ant-progress-outer': {
      width: 100,
    }
  },
  ...getVariableStyle(),

  inttraButton: {
    fontSize: tokens.fontSize.caption,
    height: 28,
    color: tokens.colors.text,
    borderColor: '#999999',
    fontWeight: tokens.fontWeight.semibold,
  },

  pendingContainerCount: {
    fontSize: '11px',
    display: 'block',
    backgroundColor: 'rgba(255,210,142,0.15)',
    padding: `${tokens.spacing.xs}px ${tokens.spacing.sm}px`,
    borderRadius: tokens.radius.sm,
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.textSecondary,
  },
  requestForm13ButtonDisabled: {
    ...buttonStyle('#FFFFFF', '#999999', '1px solid #999999'),
    margin: '6px 0',
    borderRadius: tokens.radius.sm,
    fontSize: tokens.fontSize.small,
    cursor: 'not-allowed',
  },
  taskListContainer: {
    // maxHeight: 'calc(100vh - 170px)',
    // overflowY: 'auto',
    // height: 'max-content',
    backgroundColor: '#F1EEE8'
  }
}));

export default styles;
